import { createContext } from 'react';
import type { CSSProperties } from 'react';
import type { ViewportMetrics } from '../hooks/useViewportMetrics';
import { defaultViewportMetrics } from '../hooks/useViewportMetrics';

export type ShellLayoutMode = 'desktop' | 'mobile';

export type ShellSlotName =
  | 'top-utility-start'
  | 'top-utility-end'
  | 'menu-content'
  | 'menu-secondary'
  | 'menu-secondary-start'
  | 'menu-secondary-end'
  | 'floating-action';

export interface ShellSlotDefinition {
  className: string;
  style?: CSSProperties;
}

export interface LayoutContextValue {
  viewport: ViewportMetrics;
  shellMode: ShellLayoutMode;
  isMobileShell: boolean;
  slots: Record<ShellSlotName, ShellSlotDefinition>;
}

const defaultSlots: Record<ShellSlotName, ShellSlotDefinition> = {
  'top-utility-start': { className: '' },
  'top-utility-end': { className: '' },
  'menu-content': { className: '' },
  'menu-secondary': { className: '' },
  'menu-secondary-start': { className: '' },
  'menu-secondary-end': { className: '' },
  'floating-action': { className: '' },
};

export const LayoutContext = createContext<LayoutContextValue>({
  viewport: defaultViewportMetrics,
  shellMode: 'desktop',
  isMobileShell: false,
  slots: defaultSlots,
});
